module.exports = __webpack_public_path__ + "static/Abacus Zeiterfassung Testimonial Sertronics-43d0f45725558fe1480bfc91cadd2954.pdf";